<div id="footer">
    <img src="../../assets/imgs/ws_logo.png" alt="">

<small> &nbsp;&nbsp; Designed and built using Angular by Adam Woolf @ <a href="http://www.webspinner.eu">WebSpinner.eu</a> </small>
&nbsp;&nbsp;<img src="../../assets/imgs/Angular_full_color_logo.svg.png" alt="">
</div>